import { render, staticRenderFns } from "./PlatformTypeCheckList.vue?vue&type=template&id=9520bc50&"
import script from "./PlatformTypeCheckList.vue?vue&type=script&lang=ts&"
export * from "./PlatformTypeCheckList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports